<template>
  <el-container class="is-vertical container-wrapper" v-loading="loading">
    <el-header height="'153px'">
      <navigation></navigation>
    </el-header>
    <sidebar v-if="($mq.resize && $mq.below('768px'))"/>
    <dashboard-content @loading="setLoading($event)"></dashboard-content>
    <taps-footer></taps-footer>
  </el-container>
</template>
<script>
import DashboardContent from './Content.vue'
import Navigation from '@/components/Navigation.vue'
import Sidebar from '@/components/Sidebar.vue'
import TapsFooter from '@/components/Footer.vue'
export default {
  data () {
    return {
      isCollapse: false,
      loading: false
    }
  },
  components: {
    Sidebar,
    Navigation,
    TapsFooter,
    DashboardContent
  },
  methods: {
    setLoading (data) {
      this.loading = data
    }
  }
}
</script>
<style lang="scss" scoped>
.container-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/BasicLayout.vue